var _style, _g, _polygon, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64",
      fill: "#000",
      version: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  \n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:none;stroke:#000000;stroke-width:0.1;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    className: "st2",
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 32,
    y1: 2,
    x2: 32,
    y2: 62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 62,
    y1: 32,
    x2: 2,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 2,
    y1: 2,
    x2: 62,
    y2: 62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    className: "st2",
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 62,
    y1: 2,
    x2: 2,
    y2: 62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 2,
    y1: 32,
    x2: 32,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 32,
    y1: 2,
    x2: 62,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 62,
    y1: 32,
    x2: 32,
    y2: 62
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 32,
    y1: 62,
    x2: 2,
    y2: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 32,
    cy: 32,
    r: 21
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "46 3 46 12 54 12 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13v16h21V13H9zM18 24c0 1.7-1.3 3-3 3h-1c-1.7 0-3-1.3-3-3v-1h2v1c0 0.6 0.4 1 1 1h1c0.6 0 1-0.4 1-1v-9h2V24zM28 19h-2v-1c0-0.6-0.4-1-1-1h-2c-0.6 0-1 0.4-1 1v1c0 0.6 0.4 1 1 1h2c1.7 0 3 1.3 3 3v1c0 1.7-1.3 3-3 3h-2c-1.7 0-3-1.3-3-3v-1h2v1c0 0.6 0.4 1 1 1h2c0.6 0 1-0.4 1-1v-1c0-0.6-0.4-1-1-1h-2c-1.7 0-3-1.3-3-3v-1c0-1.7 1.3-3 3-3h2c1.7 0 3 1.3 3 3V19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 14V2H13v9h19v20H13v31h42V14H44zM39 40h-1.6c-1.1 0-2.4 0.9-2.4 2v2.3c0 1.3-0.3 2.6-1.3 3.5v0.1V48c0.9 0.9 1.3 2.2 1.3 3.5V54c0 1.1 1.3 2 2.4 2H39v2h-1.6c-2.2 0-4.4-1.8-4.4-4v-2.3c0-0.8-0.1-1.6-0.7-2.1L30.9 48l1.4-1.5c0.6-0.6 0.7-1.3 0.7-2.1V42c0-2.2 2.2-4 4.4-4H39V40zM49.7 49.5c-0.6 0.6-0.7 1.3-0.7 2.1V54c0 2.2-2.2 4-4.4 4H43v-2h1.6c1.1 0 2.4-0.9 2.4-2v-2.3c0-1.3 0.3-2.6 1.3-3.5v-0.1V48c-0.9-0.9-1.3-2.2-1.3-3.5V42c0-1.1-1.3-2-2.4-2H43v-2h1.6c2.2 0 4.4 1.8 4.4 4v2.3c0 0.8 0.1 1.6 0.7 2.1l1.5 1.5L49.7 49.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8fbce3d9c9bb10eecac12051152213ab.svg";
export { ForwardRef as ReactComponent };